import { z } from 'zod';

import { CanonicalPaymentMethodSchema } from './finance.schemas.js';

export const PaymentMethodFinancialAccountItemSchema = z.object({
  method: CanonicalPaymentMethodSchema,
  financialAccountId: z.uuid(),
});
export type PaymentMethodFinancialAccountItem = z.infer<
  typeof PaymentMethodFinancialAccountItemSchema
>;

export const GetPlacePaymentMethodFinancialAccountsResponseSchema = z.object({
  items: z.array(PaymentMethodFinancialAccountItemSchema),
});
export type GetPlacePaymentMethodFinancialAccountsResponse = z.infer<
  typeof GetPlacePaymentMethodFinancialAccountsResponseSchema
>;

export const UpsertPlacePaymentMethodFinancialAccountsBodySchema = z.object({
  items: z.array(PaymentMethodFinancialAccountItemSchema),
});
export type UpsertPlacePaymentMethodFinancialAccountsBody = z.infer<
  typeof UpsertPlacePaymentMethodFinancialAccountsBodySchema
>;
